module.exports = __webpack_public_path__ + "static/media/1000963.caf91e43.png";